<template>
  <div class="appFooter">
		<p>ASA24 is a registered trademark of HHS.</p>
    <div class="appFooterLinks">
        <!-- Some might be links to external sites and not router links -->
				<a href="https://www.nih.gov/web-policies-notices" target="_blank" aria-label="Privacy Statement - New Window">Privacy Statement</a>&nbsp;&nbsp;|
				<a href="https://www.nih.gov/web-policies-notices" target="_blank" aria-label="Accessibility - New Window">Accessibility</a>&nbsp;&nbsp;|
        <a href="https://www.nih.gov/institutes-nih/nih-office-director/office-communications-public-liaison/freedom-information-act-office" target="_blank" aria-label="Freedom of Information Act - New Window">Freedom of Information Act</a>&nbsp;&nbsp;|
				<a href="https://www.hhs.gov/vulnerability-disclosure-policy/index.html" target="_blank" aria-label="HHS Vulnerablity Disclosure - New Window">HHS Vulnerablity Disclosure</a>
    </div>
    <div class="appFooterLinks">
        <a href="http://www.hhs.gov/" target="_blank" aria-label="Department of Health and Human Services - New Window">Department of Health and Human Services</a> &nbsp;&nbsp;|
        <a href="http://www.nih.gov/" target="_blank" aria-label="National Institutes of Health (NIH) - New Window">National Institutes of Health (NIH)</a>&nbsp;&nbsp;|
        <a href="http://www.usa.gov" target="_blank" aria-label="USA.gov - New Window">USA.gov</a>
    </div>
    <span class="appFooterText">NIH…Turning Discovery Into Health®</span>
  </div>
</template>

<script>
export default {
	name: 'AppFooter',
	props: {
	}
}
</script>

<style></style>
